import script from "./VodPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VodPage.vue?vue&type=script&setup=true&lang=js"

import "./VodPage.vue?vue&type=style&index=0&id=9b73a6d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b73a6d2"]])

export default __exports__